import React from 'react'
import PropTypes from 'prop-types'
import PCLNAnalytics from '@pcln/analytics'
import styled from 'styled-components'
import { Flex, Heading, Text, Box } from 'pcln-design-system'
import { clientErrorRedirect } from '../../helpers/clientErrorRedirect'

const Wrapper = styled(Flex)`
  height: 500px;
`

const Content = styled(Box)`
  max-width: 1400px;
  width: 100%;
`

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch(error, info) {
    const { stack, message } = error
    PCLNAnalytics.appName = this.props.appName
    PCLNAnalytics.appVersion = this.props.appVersion
    PCLNAnalytics.logError({
      stack,
      message,
    })

    // new relic error
    window?.newrelic?.noticeError(error, info)

    clientErrorRedirect()

    //TODO: Update the component below to look the same as the noresults page
    //Then uncomment this setState and remove clientErrorRedirect()
    //This will be a better user experience than redirecting
    // this.setState({
    //   hasError: true
    // })
  }

  render() {
    if (this.state.hasError) {
      return (
        <Wrapper w={1} alignItems={'center'} flexDirection={'column'} p={3}>
          <Content>
            <Heading.h1 mt={'100px'} mb={2}>
              Oops!
            </Heading.h1>
            <Heading.h2 mb={3}>Something went wrong.</Heading.h2>
            <Text>
              {`
              We're working on it and will get it fixed as soon as possible.
            `}
            </Text>
          </Content>
        </Wrapper>
      )
    }

    return this.props.children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  appName: PropTypes.string,
  appVersion: PropTypes.string,
}

export { ErrorBoundary }
